import { render } from "./ModeButton.vue?vue&type=template&id=5b074dfb&scoped=true&ts=true"
import script from "./ModeButton.vue?vue&type=script&lang=ts"
export * from "./ModeButton.vue?vue&type=script&lang=ts"

import "./ModeButton.vue?vue&type=style&index=0&id=5b074dfb&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b074dfb"]])

export default __exports__